import { BrowserRouter as Router } from 'react-router-dom';
import { Fragment } from 'react';
import { Toaster } from 'react-hot-toast';
import { AppRouts } from './routes/AppRoutes';

import { GoogleOAuthProvider } from '@react-oauth/google';

import { PageTracking } from './shared/lib/analytics/page-tracking';

import CarrotRainEasterEgg from './components/easterEggs/CarrotRainEasterEgg';

function App() {
	return (
		<Fragment>
			<CarrotRainEasterEgg />
			<GoogleOAuthProvider clientId={process.env.GOOGLE_OAUTH_CLIENT_ID}>
				<Toaster position='bottom-right' />
				<Router>
					<PageTracking />
					<AppRouts />
				</Router>
			</GoogleOAuthProvider>
		</Fragment>
	);
}

export default App;
